import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";

export default function Testimonials() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setList(r.data)); }, []);

  return (
    <div data-testid="testimonials-page" className="pt-24">
      <section className="container mx-auto px-4 pt-16 pb-12">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-3">Testimonials</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none mb-6 max-w-4xl">
          Voices of <span className="text-gradient">happy founders</span>.
        </h1>
      </section>

      <section className="container mx-auto px-4 pb-24 grid md:grid-cols-2 gap-6">
        {list.map((t, i) => (
          <div key={t.id} data-testid={`tess-card-${t.id}`}
            className={`p-8 rounded-2xl border ${i % 3 === 0 ? "bg-[#0A1128] text-white border-[#0A1128]" : "bg-white border-zinc-200"}`}>
            <div className="flex gap-1 mb-3">
              {Array.from({ length: t.rating }).map((_, j) => (
                <Star key={j} className="w-4 h-4 fill-[#FF7F00] text-[#FF7F00]" />
              ))}
            </div>
            <p className={`text-lg leading-relaxed mb-6 ${i % 3 === 0 ? "text-white" : "text-[#0A1128]"}`}>"{t.quote}"</p>
            <div className="flex items-center gap-3">
              <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
              <div>
                <div className="font-bold text-sm">{t.name}</div>
                <div className={`text-xs ${i % 3 === 0 ? "text-white/60" : "text-zinc-500"}`}>{t.role}, {t.company}</div>
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
